<template>
    <vue-draggable-resizable
        class="custom-resizable"
        :draggable="false"
        :handles="handles"
        :onResize="onResize"
        :maxWidth="maxWidth"
        :minWidth="minWidth"
        :w="width"
    >
        <slot />
    </vue-draggable-resizable>
</template>
<script>
import VueDraggableResizable from "vue-draggable-resizable";
import _ from "lodash";

export default {
    name: "ResizableContent",
    components: {
        VueDraggableResizable,
    },
    props: {
        width: {
            type: [String, Number],
            default: 0,
        },
        minWidth: {
            type: Number,
            default: null,
        },
        maxWidth: {
            type: Number,
            default: null,
        },
        handles: {
            type: Array,
            default: () => [],
        },
        onResize: {
            type: Function,
            default: () => _.noop,
        },
    },
    data: () => ({
        touched: false,
        beforeDestroyListeners: [],
        listeners: [],
    }),
    methods: {},
    mounted() {},
};
</script>
<style>
.custom-resizable {
    position: relative;
    width: 100%;
    height: 100% !important;
    transform: translate(0px, 0px) !important;

    .handle {
        position: absolute;
        top: 0;
        cursor: col-resize;
        display: block !important;

        &:hover,
        &:focus,
        &:active {
            background: var(--border-neutral-default);
        }

        &.handle-mr {
            right: 0;
            width: 5px;
            height: 100%;
        }

        &.handle-ml {
            left: 0;
            width: 5px;
            height: 100%;
        }
    }
}
</style>
